import * as types from "../../constants";
import { clearPatientsStore } from "../../db";
import {
  signIn as authSignIn,
  signUp as authSignUp,
  resetPassword as authResetPassword,
} from "../../services/authService";
import { clearSession } from "../../services/sessionLifecycle";
import { addBreadcrumb } from "../../utils/diagnostics/breadcrumbs";

export function signIn(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_SIGN_IN_REQUEST });

    return authSignIn(credentials)
      .then((response) => {
        dispatch({
          type: types.AUTH_SIGN_IN_SUCCESS,
          id: response.id,
          email: response.email,
          name: response.name,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_SIGN_IN_FAILURE });
        throw error;
      });
  };
}

export function signUp(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_SIGN_UP_REQUEST });

    return authSignUp(credentials)
      .then((response) => {
        dispatch({
          type: types.AUTH_SIGN_UP_SUCCESS,
          id: response.id,
          email: response.email,
          name: response.name,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_SIGN_UP_FAILURE });
        throw error;
      });
  };
}

// SHER-209 — `reason` is passed straight through to clearSession so a teardown
// is attributable without resolving a minified stack. Defaults to 'sign-out',
// which is the deliberate case and the one that does NOT raise the alarm; a
// caller expelling the user for another cause should say so (see Dashboard.jsx).
export function signOut(reason = 'sign-out') {
  return async (dispatch) => {
    // Capture a short stack trace so the next time AUTH_SIGN_OUT fires
    // unexpectedly (as observed in the ATTADIR chom-dakar session), the
    // diagnostic breadcrumbs tell us which caller triggered it, not just
    // that the reducer ran.
    try {
      const stack = new Error('signOut.dispatch').stack || '';
      const shortStack = stack.split('\n').slice(1, 6).join(' | ');
      addBreadcrumb('state', 'auth.signOut.dispatched', {
        route: typeof window !== 'undefined' ? window.location?.pathname : undefined,
        errorName: reason,
        errorMessage: shortStack.slice(0, 400),
      });
    } catch (_) { /* never break sign-out */ }
    // SHER-215 — drop axios's default Authorization header *before* awaiting
    // clearPatientsStore so any pagination/sync that fires during the await
    // can't carry the previous user's JWT into a fresh request.
    clearSession(reason);
    // SHER-582: a clearPatientsStore() rejection (e.g. IndexedDB.clear() throwing)
    // must never skip the AUTH_SIGN_OUT dispatch below — otherwise every org-scoped
    // Redux slice keeps the previous org's data across the next login, which is
    // exactly the cross-organisation leak this ticket is about. Isolate the failure.
    try {
      await clearPatientsStore();
    } catch (err) {
      console.error('signOut: clearPatientsStore failed; continuing sign-out', err);
    }
    dispatch({
      type: types.AUTH_SIGN_OUT,
    });
  };
}

export function resetPassword(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_RESET_PASSWORD_REQUEST });

    return authResetPassword(credentials)
      .then((response) => {
        dispatch({
          type: types.AUTH_RESET_PASSWORD_SUCCESS,
          email: response.email,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_RESET_PASSWORD_FAILURE });
        throw error;
      });
  };
}
